var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoryAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.75C3.5 2.33579 3.16421 2 2.75 2C2.33579 2 2 2.33579 2 2.75V20C2 21.1046 2.89543 22 4 22H5V18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18V22H15V18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18V22H20C21.1046 22 22 21.1046 22 20V3.76619C22 2.9889 21.152 2.50878 20.4855 2.9087L12.4855 7.7087C12.1843 7.88942 12 8.21493 12 8.56619V3.76619C12 2.9889 11.152 2.50878 10.4855 2.9087L3.5 7.1V2.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryAlt2);
export default __webpack_public_path__ + "static/media/factory-alt-2.e2e20deb847171a7923a18e61b1e01ff.svg";
export { ForwardRef as ReactComponent };